import { render, staticRenderFns } from "./DateSeparator.vue?vue&type=template&id=62e8ba37&scoped=true&"
import script from "./DateSeparator.vue?vue&type=script&lang=js&"
export * from "./DateSeparator.vue?vue&type=script&lang=js&"
import style0 from "./DateSeparator.vue?vue&type=style&index=0&id=62e8ba37&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e8ba37",
  null
  
)

export default component.exports